import SelectLevel from '../content/select_lvl';
import UplevelCriteria from '../content/uplevel_ctr';
import RenewalCriteria from '../content/renewal_ctr';
import CompanyInfo from '../content/company_info';
import AddContacts from '../content/add_conts';
import Questionnaire1 from '../content/questions1';
import Questionnaire2 from '../content/questions2';
import ProgramAgreement from '../content/prog_agmnt';
import Finish from '../content/finish';

import NonPartnerAccount from '../content/nonPartnerAcc';
import RegAnotherProg from '../content/regWithAnotherProg';
import SubmittedInReview from '../content/submittedInReview';
import RenewalSubmitted from '../content/renewalSubmitted';
import GenericError from '../content/genericError';


const ContentMap = {
    forms : [SelectLevel,UplevelCriteria,CompanyInfo,AddContacts,Questionnaire1,Questionnaire2,ProgramAgreement,Finish],
    renewalForms : [RenewalCriteria,CompanyInfo,AddContacts,Questionnaire1,Questionnaire2,ProgramAgreement,Finish],
    renewalFormsRegistered : [RenewalCriteria,CompanyInfo,AddContacts,ProgramAgreement,Finish],
    stepList : [0,1,2,3,4,4,5,5],
    stepListRenewal : [0,1,2,3,3,4,4],
    stepListRenewalRegistered : [0,1,2,3,3],
    unavailable : [RegAnotherProg,NonPartnerAccount,GenericError,SubmittedInReview,RenewalSubmitted],
    languageNameCode : {English: 'en_US', Chinese: 'zh_CN', French: 'fr_FR', German: 'de_DE', Italian: 'it_IT', Japanese: 'ja_JP', Korean: 'ko_KR', Spanish: 'es_ES'},
};

export {ContentMap};